import { LinearProgress, LoaderOverlay, Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import { FileOperationProgress, useFileOperationOverlay } from 'broker/components/FilesExplorer/hooks';

function getProgressText(progress: FileOperationProgress): string {
  switch (progress.phase) {
    case 'preparing':
      return messages.fileExplorer.truncatePreparing;
    case 'downloading':
      return messages.fileExplorer.truncateDownloading;
    case 'loading':
      return messages.fileExplorer.truncateLoading;
    case 'truncating':
      return messages.fileExplorer.truncateTruncating;
    case 'uploading':
      return messages.fileExplorer.truncateUploading;
    default:
      return messages.fileExplorer.truncateTruncating;
  }
}

export default function FileOperationOverlay() {
  const { operation } = useFileOperationOverlay();

  if (!operation) {
    return null;
  }

  // Simple overlay - just show a message with indeterminate spinner
  if (operation.type === 'simple') {
    return <LoaderOverlay text={operation.message} />;
  }

  // Progress overlay - show detailed progress with progress bar
  const { progress, fileName, message } = operation;
  const progressText = message || getProgressText(progress);

  return (
    <LoaderOverlay
      text={progressText}
      extraContent={
        <Stack sx={{ width: 360 }} gap={1.5}>
          <LinearProgress
            variant={progress.phase === 'truncating' ? 'determinate' : 'indeterminate'}
            {...(progress.phase === 'truncating'
              ? { value: (progress.pagesProcessed / progress.totalPages) * 100 }
              : {})}
          />
          {fileName ? (
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              {fileName}
            </Typography>
          ) : null}
          {progress.phase === 'truncating' ? (
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              {messages.fileExplorer.truncateProgress(progress.pagesProcessed, progress.totalPages)}
            </Typography>
          ) : null}
        </Stack>
      }
    />
  );
}
